import Vue from 'vue'
import VueRouter from 'vue-router'
import Firebase from '../firebase.js'
import Dashboard from '../views/Dashboard.vue'

const appName = 'Property Manager';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    alias: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: `Dashboard | ${appName}`,
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: `Login | ${appName}`,
    }
  },
  {
    path: '/properties/',
    name: 'Properties',
    component: () => import('../views/Properties.vue'),
    meta: {
      title: `View Properties | ${appName}`,
      requiresAuth: true
    },
    children: [
      {
        path: 'add',
        name: 'Add Property',
        component: () => import('../views/Properties/ManageProperty.vue'),
        props: {id: null},
        meta: {
          title: `Add New Property | ${appName}`,
        }
      },
      {
        path: 'edit/:id',
        name: 'Edit Property',
        component: () => import('../views/Properties/ManageProperty.vue'),
        props: true,
        meta: {
          title: `Edit Property | ${appName}`,
        }
      },
      {
        path: 'detail/:id',
        name: 'Property Detail',
        component: () => import('../views/Properties/PropertyDetail.vue'),
        props: true,
        meta: {
          title: `View Property Details | ${appName}`,
        }
      },
    ]
  },
  {
    path: '/reminders/:id?',
    name: 'Reminders',
    component: () => import('../views/Reminders.vue'),
    props: true,
    meta: {
      title: `View Reminders | ${appName}`,
      requiresAuth: true
    },
  },
  {
    path: '/maintenance-requests/:id?',
    name: 'Maintenance Requests',
    component: () => import('../views/MaintenanceRequests.vue'),
    props: true,
    meta: {
      title: `View Maintenance Requests | ${appName}`,
      requiresAuth: true
    },

  },
  {
    path: '*',
    name: '404 Page',
    component: () => import('../views/ErrorPage.vue'),
    meta: {
      title: `Page Not Found | ${appName}`,
    },

  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  if (requiresAuth && !Firebase.auth.currentUser) {
    next('/login')
  } else {
    next()
  }
})


export default router
